<form [formGroup]="form" [glPremium]="true">
  <div class="vehicleToLoadWrapper">
    <gl-checkbox
      [defaultChecked]="this.form.get('palletVehicleToLoad').value"
      [ngClass]="{ disabledCheckbox: !isEdit }"
      class="checkbox"
      formControlName="palletVehicleToLoad"
      >
      {{ 'pick_vehicle_to_load' | translate }}
    </gl-checkbox>
    <div class="vehicleSelectWrapper">
      <div class="vehicleSelectContainer">
        <div class="vehicleToLoad" [ngClass]="{ opacity: !isEdit }">
          <gl-icon [name]="'undo'" class="dropdown"></gl-icon>
          @if (choosenWorkspace !== null && loadingSpace.palletVehicle !== null) {
            <gl-loading-space-list-element
              (chosen)="onChosenValue()"
              [hoverActive]="false"
              [isButtons]="false"
              [loadingSpace]="choosenWorkspace"
              [ngClass]="{ edit: isEdit }"
              class="vehicle"
            ></gl-loading-space-list-element>
          }
          @if (choosenWorkspace === null || !loadingSpace.palletVehicle) {
            <div
              (click)="onChosenValue()"
            [ngClass]="{
              disabled: !isEdit || !(cargoSpaces?.length > 0)
            }"
              class="emptyContainer"
              >
              <p class="emptyInfo">{{ 'choose_vehicle' | translate }}</p>
            </div>
          }
        </div>
        @if (isSelectOpen) {
          <div class="vehicleToLoadList">
            @for (loadingSpace of workSpaces; track loadingSpace) {
              <gl-loading-space-list-element
                (chosen)="onChosenSelect($event)"
                [hoverActive]="false"
                [isButtons]="false"
                [loadingSpace]="loadingSpace"
                class="vehicleList"
              ></gl-loading-space-list-element>
            }
          </div>
        }
      </div>
    </div>
    <gl-modal-hint class="infoWrapper">
      <p>
        {{ 'choose_vehicle_info' | translate }}
      </p>
    </gl-modal-hint>
  </div>
</form>
